import { AlertCircle } from 'lucide-react'

import { StatusScreen, type StatusScreenProps } from '@/components/screens/StatusScreen'

export interface ErrorScreenProps extends Omit<StatusScreenProps, 'tone' | 'icon' | 'actionLabel'> {
  /** Action button label. @default 'Reload' */
  actionLabel?: string
}

/** Something went wrong: the error tone and icon of `StatusScreen`. A good or neutral outcome uses `StatusScreen`. */
export function ErrorScreen({ actionLabel = 'Reload', ...props }: ErrorScreenProps) {
  return <StatusScreen tone="error" icon={AlertCircle} actionLabel={actionLabel} {...props} />
}

export default ErrorScreen
